// import React, { ElementType } from "react";
// import {
//   Box,
//   Button,
//   Flex,
//   Heading,
//   Text,
//   VStack,
//   HStack,
//   Icon,
//   useColorModeValue,
// } from "@chakra-ui/react";
// import { useNavigate } from "react-router-dom";
// import { MdEmail, MdArrowBack } from "react-icons/md";

// /**
//  * EmailComingSoonPage
//  * Route suggestion: /organization/inbox/email
//  *
//  * Props: none (optional: read orgId from route if you want)
//  */
// export default function EmailComingSoonPage() {
//   const navigate = useNavigate();
//   const cardBg = useColorModeValue("white", "gray.800");

//   return (
//     <Flex
//       minH="100vh"
//       align="center"
//       justify="center"
//       bgGradient="linear(to-b, #f6fff6, #eef7ee)"
//       px={6}
//       py={12}
//     >
//       <Box
//         maxW="760px"
//         w="100%"
//         bg={cardBg}
//         rounded="2xl"
//         shadow="lg"
//         p={{ base: 6, md: 10 }}
//       >
//         <HStack spacing={6} align="start">
//           <Box
//             bg="#006400"
//             rounded="xl"
//             p={4}
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//             minW="72px"
//             minH="72px"
//             boxShadow="md"
//           >
//             <Icon as={MdEmail as ElementType} boxSize={8} color="white" />
//           </Box>

//           <Box flex="1">
//             <Heading size="lg" color="#006400" mb={2}>
//               Email Inbox — Coming Soon
//             </Heading>

//             <Text color="gray.600" fontSize="md" mb={4}>
//               We’re building a powerful email inbox that integrates directly with your organization —
//               bringing messages, contact history, and follow-ups into one place alongside your CRM.
//             </Text>

//             <VStack align="start" spacing={2} mb={6}>
//               <Text color="gray.700">What to expect when it's ready:</Text>
//               <Box as="ul" pl={4} color="gray.600">
//                 <li>Unified email threading per lead and contact.</li>
//                 <li>Automatic association of emails to leads and conversations.</li>
//                 <li>Rich templates and one-click sends right from the CRM.</li>
//                 <li>Smart inbox rules, snooze & scheduled follow-ups.</li>
//               </Box>
//             </VStack>

//             <HStack spacing={3}>
//               <Button
//                 leftIcon={<Icon as={MdArrowBack as ElementType} boxSize={4} />}
//                 variant="outline"
//                 onClick={() => navigate(-1)}
//               >
//                 Back
//               </Button>

//               <Button
//                 bg="#006400"
//                 color="white"
//                 _hover={{ bg: "#004d00" }}
//                 onClick={() => {
//                   // Example: take user to inbox overview or notify signup
//                   navigate("/organization/home"); // adapt as needed
//                 }}
//               >
//                 Go to Organization Home
//               </Button>
//             </HStack>
//           </Box>
//         </HStack>

//         <Text mt={6} color="gray.500" fontSize="sm" textAlign="center">
//           Want early access or to test the inbox? Contact your admin or email support — we’ll
//           prioritize beta invites for active users.
//         </Text>
//       </Box>
//     </Flex>
//   );
// }

import React, { ElementType } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  VStack,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { MdEmail, MdArrowBack } from "react-icons/md";

export default function EmailComingSoonPage() {
  const navigate = useNavigate();
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.700", "gray.300");

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="#FCE8E6"
      px={6}
      py={12}
    >
      <Box
        maxW="760px"
        w="100%"
        bg={cardBg}
        rounded="2xl"
        shadow="lg"
        p={{ base: 6, md: 10 }}
        textAlign="center"
      >
        {/* Gmail-style top icon */}
        <Box
          bg="#D93025"
          rounded="full"
          p={5}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="md"
          mb={6}
        >
          <Icon as={MdEmail as ElementType} boxSize={12} color="white" />
        </Box>

        <Heading size="lg" color="#D93025" mb={3}>
          Email Inbox - Coming Soon
        </Heading>

        <Text color={textColor} fontSize="md" maxW="620px" mx="auto" mb={6}>
          Get ready for a smarter, Gmail-style inbox experience inside your CRM.
          Manage messages, track conversations, and send follow-ups - all in one place.
        </Text>

        <VStack align="start" spacing={2} maxW="620px" mx="auto" mb={8}>
          <Text color={textColor} fontWeight="semibold">
            What to expect:
          </Text>
          <Box as="ul" pl={4} color={textColor} fontSize="sm">
            <li>• Unified email threads per lead and contact.</li>
            <li>• Smart templates and quick replies.</li>
            <li>• CRM-linked activity tracking and reminders.</li>
            {/* <li>• Familiar Gmail-inspired interface.</li> */}
          </Box>
        </VStack>

        <Flex justify="center" gap={4}>
          <Button
            leftIcon={<Icon as={MdArrowBack as ElementType} boxSize={4} />}
            variant="outline"
            borderColor="#D93025"
            color="#D93025"
            _hover={{ bg: "#D93025", color: "white" }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>

          <Button
            bg="#D93025"
            color="white"
            _hover={{ bg: "#B1271D" }}
            onClick={() => navigate("/organization/home")}
          >
            Go to Organization Home
          </Button>
        </Flex>

        <Text mt={8} color="gray.500" fontSize="sm">
          Want early access? Contact your admin or email support - beta invites open soon.
        </Text>
      </Box>
    </Flex>
  );
}
